export const INITIAL = 'Nothing';

export const KEY_LISTS = ['Today', 'Planned', 'Important', 'All'];
export const KEY_COLORS = ['#3478f6', '#ea4e3d', '#f09a37', '#AF5BDC'];
export const KEY_COLORS_L2 = ['#e0e7f5', '#ead4d2', '#f0e7dc', '#dbd3e0'];
export const KEY_COLORS_L3 = ['#6498f9', '#f7877b', '#ffb868', '#c693e2'];
export const KEY_COLORS_D1 = ['#071124', '#140d0c', '#16120d', '#0e0115'];
export const KEY_COLORS_D2 = ['#3966B9', '#B0382A', '#BC7B31', '#7E439D'];

export const DEFAULT_COLOR = KEY_COLORS[0];
export const DEFAULT_COLORL2 = KEY_COLORS_L2[0];
export const DEFAULT_COLORL3 = KEY_COLORS_L3[0];
export const DEFAULT_COLORD1 = KEY_COLORS_D1[0];
export const DEFAULT_COLORD2 = KEY_COLORS_D2[0];

export const DEFAULT_LIST = KEY_LISTS[0];

export const COLORS = [
  '#3478f6',
  '#54A2CE',
  '#41B64B',
  '#83C231',
  '#f09a37',
  '#ea4e3d',
  '#A99068',
  '#d8506c',
  '#AF5BDC',
  '#5958E4',
];

export const COLORS_L2 = [
  '#e0e7f5',
  '#e0e6ec',
  '#e0ede1',
  '#ecffce',
  '#f0e7dc',
  '#ead4d2',
  '#f1ece5',
  '#f1e1e4',
  '#dbd3e0',
  '#ddddf0',
];

export const COLORS_L3 = [
  '#6498f9',
  '#8ab3df',
  '#83dc8b',
  '#9dd753',
  '#ffb868',
  '#f7877b',
  '#d5b788',
  '#ee859a',
  '#c693e2',
  '#9998eb',
];

export const COLORS_D1 = [
  '#071124',
  '#0c1928',
  '#0b120b',
  '#12150e',
  '#16120d',
  '#140d0c',
  '#0f0900',
  '#150004',
  '#0e0115',
  '#000019',
];

export const COLORS_D2 = [
  '#3966B9',
  '#3B83AB',
  '#319239',
  '#639029',
  '#BC7B31',
  '#B0382A',
  '#796B53',
  '#943246',
  '#7E439D',
  '#3E3D9A',
];
